module.exports = __webpack_public_path__ + "img/cluster.c454b54a.svg";